import {IbanTypeEnum} from '../../enums/Iban-type.enum';
import {CompanyStatusEnum} from "../../enums/Company.status.enum";


export class BankModel {
  bankName: string;
  iban: string;
  bicOrSwift: string;
  ibanType: IbanTypeEnum;


  constructor(data?: Partial<BankModel>) {
    Object.assign(this, data);
  }
}

export class LegalInformationModel {
  id: string;
  name: string;
  origin: any;
  incorporationNumber: string;
  registrationCity: string;
  registrationNumber: string;
  shareCapital: string;
  vatNumber: string;
  legalForm: string;
  customLegalForm: string;
  phoneNumber: string;
  addressId: string;
  bank?: BankModel;
  subjectToVat: boolean;
  country: string;
  status?: CompanyStatusEnum;

  constructor(object?: Partial<LegalInformationModel>) {
    if (!object) { return; }

    Object.assign(this, object);
    this.bank = object.bank ? new BankModel(object.bank) : undefined;
  }
}
